import { Button, CircularProgress, Dialog, Grid } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { getLastUSerSearches, setSearchActivityQuery } from "routes/actions";
import useStyles from "styles";
import searchIcon from "assets/icon/Search.svg";
import userIcon from "assets/icon/vuesax-linear-profile-2user.svg";
import unitIcon from "assets/icon/vuesax-outline-courthouse - white.svg";
import activityIcon from "assets/icon/vuesax-linear-gallery.svg";

export default function SearchDialog({ open, handleClose }) {
	const classes = useStyles();
	const [searchValue, setSearchValue] = useState("");
	const [searchField, setSearchField] = useState("user");
	const history = useHistory();
	const dispatch = useDispatch();
	const { searchHistoryResultList } = useSelector((state) => state.main);
	const { searchLoading } = useSelector((state) => state.main);

	const handleSearch = (e) => {
		setSearchValue(e.target.value);
	};

	const handleFocusInput = (e) => {
		dispatch(getLastUSerSearches());
	};

	const handleSetSearchField = (field) => {
		setSearchField(field);
	};

	const searchRequest = (e) => {
		handleClose();
		if (searchField === "user") {
			dispatch(setSearchActivityQuery(searchValue));
			history.push(`/search/user/${searchValue}`);
		}

		if (searchField === "unit") {
			dispatch(setSearchActivityQuery(searchValue));
			history.push(`/search/unit/${searchValue}`);
		}

		if (searchField === "activity") {
			dispatch(setSearchActivityQuery(searchValue));
			history.push(`/activities/search`);
		}
	};
	return (
		<Dialog
			open={open}
			maxWidth="xl"
			onClose={handleClose}
			style={{ zIndex: 3000 }}
			classes={{ paper: classes.mobileSearchDialogPaper }}
		>
			<Grid container direction="column">
				<Grid container>
					<input
						className={classes.activeInput}
						value={searchValue}
						onChange={handleSearch}
						onFocus={handleFocusInput}
						placeholder="جستجو"
					/>
					<img
						src={searchIcon}
						style={{ position: "absolute", left: 22, top: 22, cursor: "pointer" }}
						alt="search"
						onClick={searchRequest}
					/>
				</Grid>
				<Grid container justify="space-between" style={{ marginTop: "20px", padding: "0 10px" }}>
					<Grid
						container
						className={searchField === "user" ? classes.activeSearchSection : classes.searchSection}
						onClick={() => handleSetSearchField("user")}
					>
						<img src={userIcon} alt="userIcon" style={{ marginLeft: 3, width: 17 }} />
						اعضا
					</Grid>
					<Grid
						container
						className={searchField === "unit" ? classes.activeSearchSection : classes.searchSection}
						onClick={() => handleSetSearchField("unit")}
					>
						<img src={unitIcon} alt="unitIcon" style={{ marginLeft: 3, width: 17 }} />
						مدرسه
					</Grid>
					<Grid
						container
						className={searchField === "activity" ? classes.activeSearchSection : classes.searchSection}
						onClick={() => handleSetSearchField("activity")}
					>
						<img src={activityIcon} alt="unitIcon" style={{ marginLeft: 3, width: 17 }} />
						فعالیت ها
					</Grid>
				</Grid>
				<Grid
					container
					direction="column"
					style={{
						padding: "0 10px 10px 10px",
						backgroundColor: "#ffffff",
						borderRadius: 10,
						margin: "20px 0",
					}}
				>
					{searchField === "user" && (
						<>
							<Grid
								item
								style={{
									borderBottom: "1px solid #bbb",
									margin: "10px 0",
								}}
							>
								سابقه جستجو
							</Grid>
							{searchHistoryResultList?.user?.slice(0, 4).map((item) => (
								<Grid item>{item}</Grid>
							))}
						</>
					)}

					{searchField === "unit" && (
						<>
							<Grid
								item
								style={{
									borderBottom: "1px solid #bbb",
									margin: "10px 0",
								}}
							>
								سابقه جستجو
							</Grid>
							{searchHistoryResultList?.unit?.slice(0, 4)?.map((item) => (
								<Grid item>{item}</Grid>
							))}
						</>
					)}
					{searchField === "activity" && (
						<>
							<Grid
								item
								style={{
									borderBottom: "1px solid #bbb",
									margin: "10px 0",
								}}
							>
								سابقه جستجو
							</Grid>
							{searchHistoryResultList?.activity?.slice(0, 4)?.map((item) => (
								<Grid item>{item}</Grid>
							))}
						</>
					)}
				</Grid>
				<Button
					color="primary"
					disabled={searchField === "default" || !searchValue?.length}
					className={classes.searchSubmit}
					classes={{ disabled: classes.searchSubmitDisabled }}
					onClick={searchRequest}
				>
					جستجو
				</Button>
			</Grid>
		</Dialog>
	);
}
